import { Component, Input, OnInit } from '@angular/core';
import { RenaultLocalCampaignCardDTO } from '../../../models/renault-local-campaign-dto';
import { Helpers } from '../../../helpers/helpers';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';

@Component({
  selector: 'local-campaign-card',
  templateUrl: './local-campaign-card.component.html',
  styleUrls: ['./local-campaign-card.component.scss']
})
export class LocalCampaignCardComponent implements OnInit {

  buttonAction: string = '';

  @Input() model: RenaultLocalCampaignCardDTO;
  @Input() user: RenaultUserDTO;

  constructor(private helper: Helpers) { }

  ngOnInit(): void {

    switch (this.model.IdCampaignMedia) {
      case 3:
        this.buttonAction = 'Realizar campaña';
        break;
      default:
        this.buttonAction = 'Configurar';
        break;
    }

  }

  ngAfterViewInit(): void {
  
    this.helper.enableBsTooltips();

  }
  
}
